import { SelectProps } from "antd";
import useFormaPagamentos from "core/features/forma-pagamento/hooks/useFormaPagamentos";
import SelectBaseAntd from "../SelectBaseAntd";

export interface SelectFormaPagamentoProps<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any) => void;
  queryParams?: {
    aceitaRecebimentoOnline?: boolean;
    ativo?: boolean;
  };
}

function SelectFormaPagamento({
  isInvalid,
  value,
  onChange,
  queryParams,
  ...rest
}: SelectFormaPagamentoProps) {
  const { isLoading, data } = useFormaPagamentos(queryParams);

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      size="large"
      loading={isLoading}
      getPopupContainer={(node) => node.parentNode}
      placeholder="Forma de pagamento"
      value={value}
      onChange={(ev) => {
        onChange(ev);
      }}
      options={data?.map((item) => ({
        label: item.nome,
        value: item.id,
      }))}
      {...rest}
    />
  );
}

export default SelectFormaPagamento;
